/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trick_Good_Lamb_RippleInputs */

const en_trick_good_lamb_ripple = /** @type {(inputs: Trick_Good_Lamb_RippleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faucet`)
};

/**
* | output |
* | --- |
* | "Faucet" |
*
* @param {Trick_Good_Lamb_RippleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const trick_good_lamb_ripple = /** @type {((inputs?: Trick_Good_Lamb_RippleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trick_Good_Lamb_RippleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_trick_good_lamb_ripple(inputs)
});